import { dossierRows } from "@/mocks/homeData";

export default function DossierIndex() {
  return (
    <section id="dossier" className="scroll-mt-24">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-start">
          <div className="lg:col-span-4">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">Dossier / 人物档案</p>
            <h2 className="mt-2 font-heading text-2xl font-black leading-tight tracking-tight text-foreground-950 md:text-3xl md:leading-tight">
              按人物分批排好，
              <br />
              收藏当目录用
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              编号越靠前争议越热。每行一条旧账主线，右侧状态提醒你「这页还会不会更新」。后续新料持续补进对应档案，回来看一眼就有增量。
            </p>
            <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-2 text-sm font-medium text-accent-700">
              <i className="ri-bookmark-line text-base leading-none" />
              新料永远补在原篇，不另开新帖
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
              <div className="hidden grid-cols-12 items-center gap-3 border-b border-background-200 bg-background-100/70 px-5 py-3 text-xs font-medium text-foreground-600 sm:grid">
                <span className="col-span-1">No.</span>
                <span className="col-span-3">人物</span>
                <span className="col-span-4">旧账主线</span>
                <span className="col-span-2">状态</span>
                <span className="col-span-2 text-right">热度 / 评论</span>
              </div>
              <div className="divide-y divide-background-200">
                {dossierRows.map((row) => (
                  <a
                    key={row.no}
                    href="#comments"
                    className="group grid grid-cols-12 items-center gap-3 px-5 py-4 transition-colors hover:bg-background-100 cursor-pointer"
                  >
                    <span className="col-span-2 font-heading text-sm font-bold text-foreground-400 group-hover:text-primary-500 sm:col-span-1">
                      {row.no}
                    </span>
                    <div className="col-span-10 sm:col-span-3">
                      <p className="text-sm font-bold text-foreground-950 group-hover:text-primary-600">{row.name}</p>
                      <p className="mt-0.5 text-xs text-foreground-500">{row.zone}</p>
                    </div>
                    <div className="col-span-10 col-start-3 mt-1 flex items-center gap-2 sm:col-span-4 sm:col-start-auto sm:mt-0">
                      <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">{row.tag}</span>
                      <span className="truncate text-xs text-foreground-700 sm:text-sm">{row.mainline}</span>
                    </div>
                    <div className="col-span-6 sm:col-span-2">
                      <span
                        className={`inline-flex items-center gap-1 text-xs font-medium ${
                          row.status === "续料中" ? "text-primary-600" : "text-foreground-500"
                        }`}
                      >
                        <i className={`${row.status === "续料中" ? "ri-loader-4-line" : "ri-check-double-line"} text-sm leading-none`} />
                        {row.status}
                        <span className="text-foreground-400">· {row.updated}</span>
                      </span>
                    </div>
                    <div className="col-span-6 flex items-center justify-end gap-4 text-right text-xs text-foreground-600 sm:col-span-2">
                      <span className="inline-flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-fire-line text-primary-500" />
                        {row.heat}
                      </span>
                      <i className="ri-arrow-right-line text-base leading-none text-foreground-400 transition-transform group-hover:translate-x-1" />
                    </div>
                  </a>
                ))}
              </div>
              <div className="border-t border-background-200 px-5 py-4 text-center text-xs text-foreground-500">
                已排 26 位 · 后续新料持续补进对应档案
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}